import React, { useCallback } from 'react';
import { TopToolbar, useListContext } from 'react-admin';

import { Box, makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import PrintIcon from '@material-ui/icons/Print';

import SearchInputMobills from './Inputs/SearchInputMobills';

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    alignItems: 'center',
    margin: 0,
    padding: '0 10px 0 0',
    marginBottom: '15px',
    display: 'flex',
  },
}));

const PurpleSwitch = withStyles({
  switchBase: {
    color: '#00897B',
    '&$checked': {
      color: '#00897B',
    },
    '&$checked + $track': {
      backgroundColor: '#00897B',
    },
  },
  checked: {},
  track: {},
})(Switch);

const ListActions = ({
  currentSort,
  className,
  resource,
  filters,
  exporter,
  permanentFilter,
  hasCreate,
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  enabledCreate,
  handleCriar = () => {},
  handleImprimir = () => {},
  ...rest
}) => {
  const classes = useStyles();
  const listContext = useListContext();
  const { filterValues, setFilters, displayedFilters } = listContext;

  const aplicarFiltros = useCallback(
    (nome) => {
      if (setFilters) {
        setFilters({ ...filterValues, nome }, displayedFilters);
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  const aplicarFiltros2 = useCallback(
    (status) => {
      if (setFilters) {
        // setFilters({ ...filterValues, status }, displayedFilters);
        if (status) {
          const { periodo, ...filtersRest } = filterValues;
          setFilters({ ...filtersRest, status }, displayedFilters);
        } else {
          const { periodo, ...filtersRest } = filterValues;

          setFilters({ ...filtersRest, status }, displayedFilters);
        }
      }
    },
    [displayedFilters, filterValues, setFilters],
  );

  const handleChange = (event) => {
    aplicarFiltros2(event.target.checked);
  };

  return (
    <TopToolbar /* {...sanitizeListRestProps(rest)} */ className={classes.root}>
      <Box
        display="flex"
        justifyContent="space-between"
        flex={1}
        alignItems="center"
      >
        {/*  <Box display="flex" alignItems="center" /> */}
        <PurpleSwitch
          checked={filterValues.status}
          onChange={handleChange}
          name="checkedB"
          color="primary"
        />
        <Box display="flex" alignItems="center">
          <Box display="flex" alignItems="center" mr="15px" flex={1}>
            <Box marginLeft="0px">
              <SearchInputMobills
                color="green"
                onChange={(search) => aplicarFiltros(search)}
                placeholder="Pesquise por produto"
              />
            </Box>
          </Box>
          <Tooltip title="Nova Conferência" placement="top" aria-label="add">
            <Box
              boxShadow={2}
              borderRadius="50px"
              display="flex"
              alignItems="center"
              width="44px"
              style={{
                backgroundColor: 'white',
                height: '48px',
                width: '48px',
              }}
              mr="15px"
            >
              <IconButton
                className={classes.iconButton}
                aria-label="search"
                onClick={() => handleCriar()}
                style={{ height: '48px', width: '48px', color: '#00897B' }}
              >
                <AddIcon />
              </IconButton>
            </Box>
          </Tooltip>
          <Tooltip title="Imprimir" placement="top" aria-label="add">
            <Box
              boxShadow={2}
              borderRadius="50px"
              display="flex"
              alignItems="center"
              width="44px"
              style={{
                backgroundColor: 'white',
                height: '48px',
                width: '48px',
              }}
            >
              <IconButton
                className={classes.iconButton}
                aria-label="search"
                onClick={() => handleImprimir()}
                style={{ height: '48px', width: '48px', color: '#00897B' }}
              >
                <PrintIcon />
              </IconButton>
            </Box>
          </Tooltip>
        </Box>
      </Box>
    </TopToolbar>
  );
};

export default ListActions;
